import { Controller } from "@hotwired/stimulus"

// The ONE support entry controller (2026-08-07 unification): dropdown +
// quick-report modal for shared/_support_entry, every shell. Formerly two
// controllers (this modal-only one and prt-support-ticket's superset); the
// superset body won. Toggles uds-support-hidden, not Tailwind's hidden,
// because the SPT shell loads no Tailwind.
const HIDDEN = "uds-support-hidden"

export default class extends Controller {
  static targets = ["modal", "pageUrl", "dropdown"]

  connect() {
    this.boundEscapeHandler = this.handleEscape.bind(this)
    this.boundOutsideClick = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscapeHandler)
    document.removeEventListener("click", this.boundOutsideClick)
  }

  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasDropdownTarget) return
    if (this.dropdownTarget.classList.contains(HIDDEN)) {
      this.dropdownTarget.classList.remove(HIDDEN)
      document.addEventListener("keydown", this.boundEscapeHandler)
      document.addEventListener("click", this.boundOutsideClick)
    } else {
      this.closeDropdown()
    }
  }

  closeDropdown() {
    if (!this.hasDropdownTarget) return
    this.dropdownTarget.classList.add(HIDDEN)
    document.removeEventListener("click", this.boundOutsideClick)
    if (!this.modalIsOpen()) {
      document.removeEventListener("keydown", this.boundEscapeHandler)
    }
  }

  open() {
    if (this.hasPageUrlTarget) {
      this.pageUrlTarget.value = window.location.href
    }
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove(HIDDEN)
      document.addEventListener("keydown", this.boundEscapeHandler)
    }
    this.closeDropdown()
  }

  close() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add(HIDDEN)
      document.removeEventListener("keydown", this.boundEscapeHandler)
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      if (this.modalIsOpen()) {
        this.close()
      } else {
        this.closeDropdown()
      }
    }
  }

  handleOutsideClick(event) {
    if (this.element.contains(event.target)) return
    this.closeDropdown()
  }

  modalIsOpen() {
    return this.hasModalTarget && !this.modalTarget.classList.contains(HIDDEN)
  }
}
